import React, { FC } from 'react';
import { getText } from '../../utilities/CultureUtilities';

interface Props {
  text: any;
  culture: string | undefined;
}

const CultureText: FC<Props> = ({ text, culture }) => <span>{getText(text, culture || '')}</span>;

export default CultureText;
